import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {store} from './store.js'
import VeeValidate from 'vee-validate';

Vue.config.productionTip = false
Vue.use(VeeValidate, { validity: true });

new Vue({
  router,
  render: h => h(App),
  mounted: function(){
    store.init();
  }
}).$mount('#app')
